import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { CONTROLLERS } from '../constants';
import { Response } from '../models';
@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {}
  apiUri = environment.apiUrl;
  private getApiUri(baseUri?: string): string {
    if (
      Object.values(CONTROLLERS.PAYMENTS)
        .map((x) => baseUri?.split('/')?.[0] == x)
        .find((x) => x)
    ) {
      this.apiUri = environment.paymentApiUrl;
    } else if (
      Object.values(CONTROLLERS.TENANTS)
        .map((x) => baseUri?.split('/')?.[0] == x)
        .find((x) => x)
    ) {
      this.apiUri = environment.tenantApiUrl;
    } else if (baseUri === 'Practice/get-practice-list') {
      // Special case: tenant practice list endpoint
      this.apiUri = environment.tenantApiUrl;
    } else {
      this.apiUri = environment.apiUrl;
    }
    return this.apiUri;
  }
  public get(url: string): Observable<Response<any>> {
    return this.http.get<any>(`${this.getApiUri(url)}/${url}`);
  }
  public getById(id: string, url: string): Observable<Response<any>> {
    return this.http.get<any>(`${this.getApiUri(url)}/${url}/${id}`);
  }
  public post(url: string, body: any): Observable<Response<any>> {
    return this.http.post<any>(`${this.getApiUri(url)}/${url}`, body);
  }

  public getBlob(url: string): Observable<Blob> {
    return this.http.get(`${this.getApiUri(url)}/${url}`, {
      responseType: 'blob' as 'json',
    }) as Observable<Blob>;
  }

  public postBlob(url: string, body: any): Observable<Blob> {
    return this.http.post(`${this.getApiUri(url)}/${url}`, body, {
      responseType: 'blob' as 'json',
    }) as Observable<Blob>;
  }

  public postText(url: string, body: any): Observable<string> {
    return this.http.post(`${this.getApiUri(url)}/${url}`, body, {
      responseType: 'text' as 'json',
    }) as unknown as Observable<string>;
  }

  public postMultipartFormData(
    url: string,
    formData: FormData
  ): Observable<Response<any>> {
    return this.http.post<any>(`${this.getApiUri(url)}/${url}`, formData);
  }
  public put(id: string, url: string, body: any): Observable<Response<any>> {
    if (!id) {
      return this.http.put<any>(`${this.getApiUri(url)}/${url}`, body);
    }
    return this.http.put<any>(`${this.getApiUri(url)}/${url}/${id}`, body);
  }
  public putMultipartFormData(
    id: string,
    url: string,
    formData: FormData
  ): Observable<Response<any>> {
    if (!id) {
      return this.http.put<any>(`${this.getApiUri(url)}/${url}`, formData);
    }
    return this.http.put<any>(`${this.getApiUri(url)}/${url}/${id}`, formData);
  }
  public delete(id: string, url: string): Observable<Response<any>> {
    return this.http.delete<any>(`${this.getApiUri(url)}/${url}/${id}`);
  }
}
